<div class="ph-upload" (drop)="checkDropFile($event)" (dragover)="checkDropOver($event)">
  <div (click)="openUploadDialog()">
    <input
      type="file"
      (change)="onFileChange($event)"
      #phUploadInput
      accept=".x-png,.png,.gif,.jpeg,.jpg,.tif,.tiff,.heic,.heif"
    />
    <input type="text" [formControl]="formEl" class="hidden-el" />
    <div [class]="'ph-upload-style--' + styletype">
      <div class="loader" *ngIf="loading && formDataFile; else base">
        {{ 'GLOBAL.loading' | translate }}
      </div>

      <ng-template #base>
        <span
          *ngIf="emptyContent && formDataFile; else inProgress"
          class="ph-upload__default-wrapper"
        >
          <span *ngIf="formEl.value === 'deleted' || !formEl.value; else resultContent">{{
            'PROJECT.image_text' | translate
          }}</span>
          <ng-template #resultContent>
            <app-photo
              [currentUpload]="currentUpload"
              (emitRemoveFile)="removeFile($event)"
            ></app-photo>
          </ng-template>
        </span>
        <ng-template #inProgress>
          <span *ngIf="formDataFile">
            {{ 'PROJECT.cropping' | translate }}
          </span>
        </ng-template>
      </ng-template>
      <div #checkContentIfEmpty>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="displayConvertHeicImage"
  [dismissableMask]="false"
  [modal]="true"
  (onHide)="displayConvertHeicImage = false"
  [style]="{ width: '600px' }"
>
  <div style="padding: 40px 80px">
    <div class="modal__wrapper">
      <div class="modal__title">{{ 'PROJECT.convert_title' | translate }}</div>
      <div class="modal__description">
        <div>
          <app-ph-loader
            [ngClass]="{ static: true }"
            [show]="true"
            [fullscreen]="false"
            [static]="true"
          ></app-ph-loader>
          {{ 'PROJECT.convert_description' | translate }}
        </div>
      </div>
    </div>
  </div>
</p-dialog>
